import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { CircleSparkIcon } from '@synoptic/ui-kit/icons/react/circle-spark.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { useNavigate } from 'react-router';
import { paths } from '@/routes-utils/paths';
import {
  goToSettingsButton,
  tryAIFilters,
  tryAIFiltersContent,
  tryAIFiltersDescription,
  tryAIFiltersHeader,
} from './ai-filters.css';

export const TryAIFilters = () => {
  const navigate = useNavigate();
  return (
    <div className={tryAIFilters}>
      <div>
        <CircleSparkIcon
          color={themeVars.container.foreground.brand}
          width={16}
          height={16}
        />
      </div>
      <div className={tryAIFiltersContent}>
        <h2 className={tryAIFiltersHeader}>Try AI Filters</h2>
        <p className={tryAIFiltersDescription}>
          Describe queries, get results, and save time. To start using AI
          Filters, connect your OpenAI GPT in Settings.
        </p>
        <Button
          onClick={() => navigate(paths.settingsApiKeys)}
          variant="secondary"
          size="small"
          className={goToSettingsButton}
        >
          Go to settings
        </Button>
      </div>
    </div>
  );
};
